import { Button, Divider, Grid, Stack, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react';
import {toast} from "react-toastify";
import config from "../configuration/config.json";



const initialUserInput = {
    contact: "",
    email: "",
    fullName: "",
    queryDescription: ""
    // queryId: "",
    // status:"PENDING"
}



const ContactSection = () => {
    const [userInput, setUserInput] = useState(initialUserInput);
    const [loader, setLoader] = useState(false)
    // console.log(userInput)
    console.log({ userInput })



    const [errors, setErrors] = useState({
        contact: "",
        email: "",
        fullName: "",
        queryDescription: ""
    });

    const [userInteracted, setUserInteracted] = useState(false);

    // useEffect only runs when userInput changes or userInteracted changes
    useEffect(() => {
        if (userInteracted) {
            validateFields();
        }
    }, [userInput, userInteracted]);

    const validateFields = () => {
        const newErrors = {};

        // Validate full name
        if (userInput.fullName.trim() === "") {
            newErrors.fullName = "Full Name is required";
        } else {
            newErrors.fullName = "";
        }

        // Validate email
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userInput.email)) {
            newErrors.email = "Invalid Email";
        } else {
            newErrors.email = "";
        }

        // Validate contact (mobile number)
        if (!/^\d{10}$/.test(userInput.contact)) {
            newErrors.contact = "Invalid Mobile Number (10 digits)";
        } else {
            newErrors.contact = "";
        }

        // Validate query description
        if (userInput.queryDescription.trim() === "") {
            newErrors.queryDescription = "Query Description is required";
        } else {
            newErrors.queryDescription = "";
        }

        setErrors(newErrors);
    };

    const handleInputChange = (e) => {
        setUserInteracted(true)
        const { name, value } = e.target;
        setUserInput({ ...userInput, [name]: value });
        console.log(name)
        // validateFieldsOnInput(name);
    };


    // const handleSubmitQuery = async () => {

    //     validateFields();
    //     try {
    //         setLoader(true)

    //         const url = `${config.apiConfig.apiEndPoint}common/queries`

    //         const requestOptions = {
    //             method: 'POST',
    //             headers: { 'Content-Type': 'application/json' },
    //             body: JSON.stringify(userInput)
    //         };
    //         const response = await fetch(url, requestOptions);
    //         const data = await response.json();

    //         if (data.responseCode === 200) {

    //             toast.success(data.message);
    //             setUserInput(initialUserInput)
    //         } else {
    //             toast.error("Something Went Wrong.");
    //         }
    //     } catch (error) {
    //         toast.error(error.data.message || "Something Went Wrong.");
    //     } finally {
    //         setLoader(false)
    //     }

    //     // console.log(data)
    //     // isValidRequest().then(() => {
    //     //     serviceProvider.commonService.post(userInput).then((res: any) => {
    //     //         setLoader(false)
    //     //         if (res.responseCode === 200) {

    //     //             toast.success(res.message);
    //     //             setUserInput(initialUserInput)
    //     //         } else {
    //     //             toast.error("Something Went Wrong.");
    //     //         }
    //     //         // console.log({res})
    //     //     }).catch((err) => {
    //     //         setLoader(true)
    //     //         console.log({ err })
    //     //     })
    //     // }).catch(() => {
    //     //     toast.error('Please Provide Proper data!');
    //     //     setLoader(false);
    //     // })
    // }
    const handleSubmitQuery = async () => {
        setUserInteracted(true)
        validateFields(); // Run validation before submission

        // Check if there are any validation errors
        if (Object.values(errors).every(error => !error)) {
            try {
                setLoader(true);
                const url = `${config.apiConfig.apiEndPoint}common/queries`;
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(userInput)
                };
                const response = await fetch(url, requestOptions);
                const data = await response.json();

                if (data.responseCode === 200) {
                    toast.success("Thank you for connecting with us. We will connect with you shortly.");
                    setTimeout(()=>{
                        window.location.reload();
                    },1500)
                   
                    // setUserInput(initialUserInput);
                } else {
                    toast.error("Something Went Wrong.");
                }
            } catch (error) {
                toast.error(error.data.message || "Something Went Wrong.");
            } finally {
                setLoader(false);
            }
        } else {
            toast.error('Please Provide Proper Data.');
        } 
    }


    const isButtonDisabled = Object.values(errors).some(error => !!error) || Object.values(userInput).some(value => value.trim() === "");
    return (
        <Grid container className='contact-us-section'>
            <Grid item xs={12} className='contact-container'>
                <Grid container>
                    <Grid item xs={12} display="flex" justifyContent="center" alignItems="center"
                        mt="0.11em"
                    >
                        <Typography className='heading' variant="h5" component="h5" sx={{mt:2}}>
                            Let's connect
                            <Divider/>
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} className='contact-us-background'>
                <Stack className="contact-us-form" gap={"15px"}>
                    <TextField id="query-fullName" className='contact-us-input' size='small' type="text" name="fullName" value={userInput.fullName} onChange={handleInputChange} fullWidth variant="standard" InputProps={{ disableUnderline: true }} placeholder='Full Name' />
                    {errors.fullName && <span className="modalError">{errors.fullName}</span>}
                    {/* <span className="modalError">{errors.fullName}</span> */}
                    <TextField id="query-email" className='contact-us-input' size='small' type="email" name="email" value={userInput.email} onChange={handleInputChange} fullWidth variant="standard" InputProps={{ disableUnderline: true }} placeholder='Email' />
                    {/* <span className="modalError">{errors.email}</span> */}
                    {errors.email && <span className="modalError">{errors.email}</span>}
                    {/* <TextField id="contact" className='contact-us-input' size='small' type="tel" name="contact" value={userInput.contact} onChange={handleInputChange} inputProps={{ maxLength: 10 }} fullWidth variant="standard" InputProps={{ disableUnderline: true, sx: { ml: "10px", mr: "10px" } }} placeholder='Mobile No.' />
                    <span className="modalError" id='errorDiv-contact'></span> */}

                    {/* <TextField id="contact" className='contact-us-input' type="tel" size='small' fullWidth variant="standard" placeholder='Mobile No.' name="contact" value={userInput.contact} onChange={handleInputChange} inputProps={{ maxLength: 10 }} InputProps={{ disableUnderline: true, sx: { px: "10px" } }}  />
                    <span className="modalError" id='errorDiv-contact'></span> */}
                    <TextField id="query-contact" size='small' type='tel' placeholder='Mobile No.' name="contact" value={userInput.contact} onChange={handleInputChange} inputProps={{ maxLength: 10 }} fullWidth variant="standard" className='contact-us-input' InputProps={{ disableUnderline: true }} />
                    {errors.contact && <span className="modalError">{errors.contact}</span>}
                    {/* <span className="modalError">{errors.contact}</span> */}
                    <TextField id="query-queryDescription" className='contact-us-input' name="queryDescription" value={userInput.queryDescription} onChange={handleInputChange} size='small' multiline rows={5} fullWidth variant="standard" InputProps={{ disableUnderline: true, sx: { ml: "10px" } }} placeholder='Inquiry / How can we assist you?' />
                    {/* <span className="modalError">{errors.queryDescription}</span> */}
                    {errors.queryDescription && <span className="modalError">{errors.queryDescription}</span>}
                    <Button variant="contained" className="rounded-btn-fill" onClick={handleSubmitQuery} disabled={isButtonDisabled}>Submit</Button>
                </Stack>
            </Grid>
        </Grid>
    )
}

export default ContactSection;


